import { Injectable } from "@angular/core";
import {
	ActivatedRouteSnapshot,
	CanActivate,
	Router,
	RouterStateSnapshot,
	UrlTree,
} from "@angular/router";
import { AuthService } from "../services/auth/auth.service";

@Injectable({ providedIn: "root" })
export class AuthGuard implements CanActivate {
	constructor(
		private readonly authService: AuthService,
		private readonly router: Router,
	) {}

	canActivate(
		_route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot,
	): boolean | UrlTree {
		if (this.authService.isMaxSessionAgeExceeded()) {
			this.authService.logout({ showSessionTimeoutToast: true });
			return this.router.createUrlTree(["/auth", "login"], {
				queryParams: { returnUrl: state.url },
			});
		}
		if (!this.authService.isLoggedIn()) {
			// Preserve deep link (e.g. pasted /crm/deals) for post-login navigation.
			return this.router.createUrlTree(["/auth", "login"], {
				queryParams: { returnUrl: state.url },
			});
		}

		const onboardingStatus = this.authService.readStoredOnboardingStatus();
		if (this.authService.isIncompleteOnboardingStatus(onboardingStatus)) {
			return this.router.createUrlTree(
				this.authService.routeForOnboardingStep(onboardingStatus),
			);
		}

		return true;
	}
}

